import { Injectable } from '../dependency-injection';
import { StorageProvider } from '../types';

@Injectable()
export class LocalStorageService extends StorageProvider {
    constructor() {
        super(window.localStorage);
    }
}
